import React from "react";
import "../../App.scss";

interface Props {
  children: any;
}
export function Footer(props: Props) {
  return <div className="footerContent container">{props.children}</div>;
}
